import { FormControl, FormErrorMessage, FormHelperText, FormLabel, Input } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { MAX_VOLUNTARY_STANDSTILL_DAYS, useAwardSelection } from "./AwardSelectionContext";
import { REVEAL_ANCHORS } from "../revealAnchor";

export const VoluntaryStandstillField = ({
  id = REVEAL_ANCHORS.standstill,
  utilitiesPartIII = false,
  partI = false,
}: {
  id?: string;
  utilitiesPartIII?: boolean;
  partI?: boolean;
}) => {
  const { t } = useTranslation();
  const { standstillDays, setStandstillDays, standstillProblem } = useAwardSelection();
  const chosenDays = standstillProblem == null ? Number(standstillDays.trim()) : 0;
  return (
    <FormControl
      id={id}
      sx={{ scrollMarginTop: "1rem" }}
      isInvalid={standstillProblem === "DAYS_NOT_A_WHOLE_NUMBER_IN_RANGE"}
    >
      <FormLabel>{t("Voluntary standstill period (days)")}</FormLabel>
      <Input
        inputMode="numeric"
        autoComplete="off"
        value={standstillDays}
        onChange={(e) => setStandstillDays(e.target.value)}
        bg="smBackground"
        maxW="32"
      />
      <FormHelperText>
        {partI
          ? chosenDays > 0
            ? t("{{count}} days, chosen by you (not required — Part I sets no standstill period). Choose up to {{max}} days.", {
                count: chosenDays,
                max: MAX_VOLUNTARY_STANDSTILL_DAYS,
              })
            : t("None (not required — Part I sets no standstill period). Choose up to {{max}} days.", {
                max: MAX_VOLUNTARY_STANDSTILL_DAYS,
              })
          : utilitiesPartIII
          ? chosenDays > 0
            ? t("{{count}} days, chosen by you (not required — forsyningsforskriften § 26-8 (2)). Choose up to {{max}} days.", {
                count: chosenDays,
                max: MAX_VOLUNTARY_STANDSTILL_DAYS,
              })
            : t("None (not required — forsyningsforskriften § 26-8 (2)). Choose up to {{max}} days.", {
                max: MAX_VOLUNTARY_STANDSTILL_DAYS,
              })
          : chosenDays > 0
          ? t("{{count}} days, chosen by you (not required — FOA § 25-2 (2) a / forsyningsforskriften § 21-2 (2) a). Choose up to {{max}} days.", {
              count: chosenDays,
              max: MAX_VOLUNTARY_STANDSTILL_DAYS,
            })
          : t("None (not required — FOA § 25-2 (2) a / forsyningsforskriften § 21-2 (2) a). Choose up to {{max}} days.", {
              max: MAX_VOLUNTARY_STANDSTILL_DAYS,
            })}
      </FormHelperText>
      <FormErrorMessage>
        {t("Write a whole number of days from 0 to {{max}}", { max: MAX_VOLUNTARY_STANDSTILL_DAYS })}
      </FormErrorMessage>
    </FormControl>
  );
};
